var chunkToChildrenMap = {
	"9672": [
		2752,
		2491
	]
};
__webpack_require__.f.prefetch = function(chunkId, promises) {
	Promise.all(promises).then(function() {
		var chunks = chunkToChildrenMap[chunkId];
		for (var i = 0; Array.isArray(chunks) && i < chunks.length; i++) {
			__webpack_require__.E(chunks[i]);
		}
	});
};